<template>
    <div class="dap-info">
        <div class="dap-info-img">
            <img class="dap-info-img" :src="agentImage" :alt="dap.fullName">
        </div>
        <div class="dap-info-title">
            <div>
                <div class="key">
                    <span v-if="isMovotoAgent">Movoto {{dap.primaryGeo.city}} Agent</span>
                    <span v-else v-tip tip="This agent has recently let Movoto know they are actively working with clients.">Verified Profile</span>
                </div>
                <div>
                    <span class="f4 text-bold">{{dap.fullName}}</span>
                    <a class="link" target="_blank" v-if="dap.facebookProfile" :href="dap.facebookProfile" rel="nofollow"><span class="icon-facebook"></span></a>
                    <a class="link" target="_blank" v-if="dap.twitterProfile" :href="dap.twitterProfile" rel="nofollow"><span class="icon-twitter"></span></a>
                    <a class="link" target="_blank" v-if="dap.linkedInProfile" :href="dap.linkedInProfile" rel="nofollow"><span class="icon-linkedin"></span></a>
                </div>
            </div>
            <div class="dap-info-rate" v-if="dap.averageRating">
                <div class="text-main f7">
                    <span>{{dap.averageRating}}/5</span>
                    <template v-for="index in 5">
                        <i class="icon-star" v-if="dap.averageRating - index >= 0"></i>
                        <i class="icon-star-half" v-else-if="dap.averageRating - index > -1"></i>
                        <i class="icon-star-o" v-else></i>
                    </template>
                </div>
                <a class="link" href="#agent-reviews"><span class="f8">{{dap.reviewCount}} Reviews</span></a>
            </div>
            <div class="dap-tags">
                <div class="tag main active small" v-if="dap.workYears">
                    {{dap.workYears}} Year{{dap.workYears>1?'s':''}} Exp
                </div>
                <div class="tag main active small" v-if="dap.transactionCount">
                    {{dap.transactionCount}} Transaction{{dap.transactionCount>1?'s':''}}
                </div>
            </div>
        </div>
        <div class="dap-info-field">
            <div>
                <p class="key">License</p>
                <b v-if="dap.license">{{dap.license}}</b>
            </div>
            <div class="singleline">
                <p class="key">languages</p>
                <b v-if="dap.languages && dap.languages.length">{{dap.languages.join(', ')}}</b>
            </div>
            <div>
                <p class="key">Licensed Since</p>
                <b>{{dap.workSince}}</b>
            </div>
            <div class="singleline" v-if="dap.officeInfo">
                <p class="key">Brokerage</p>
                <b>{{dap.officeInfo.displayName}}</b>
            </div>
        </div>
        <button class='btn primary large' @click="this.openBankrate">Get Preapproved</button>
        <div class="dap-info-detail">
            <div class="key">Specialties</div>
            <ul class="list">
                <li v-for="item in dap.specialities">
                    <button class="btn secondary small">
                        {{item}}
                    </button>
                </li>
            </ul>
        </div>
        <div class="dap-info-detail" v-if="dap.description">
            <div class="key">
                About {{dap.firstName}}
            </div>
            <div class="dap-info-desc" v-html="dap.description"></div>
            <a class="more link" @click="toggle">{{showMore? 'Show Less' : 'Show More'}}</a>
        </div>
    </div>
</template>
<script src="./dap-info.js"></script>
<style lang="scss">
@use "./dap-info.scss" as *;
</style>